import { playSound } from '@lib/utils/common'
import { useTransition, animated } from '@react-spring/web'
import classNames from 'classnames'
import { useEffect, useState } from 'react'

type Props = {
  setNextStep: () => void
  numericCountDownSound: HTMLAudioElement
  goCountDownSound: HTMLAudioElement
}

const COUNT_DOWN_TEXT = ['GO', '1', '2', '3']

const CountDown = ({
  setNextStep,
  numericCountDownSound,
  goCountDownSound,
}: Props) => {
  const [countDown, setCountDown] = useState<number>(3)
  const tranistions = useTransition(COUNT_DOWN_TEXT[countDown], {
    from: { opacity: 0, scaleY: 0 },
    enter: { opacity: 1, scaleY: 1 },
    leave: { opacity: 0, scaleY: 0 },
    config: { duration: 200 },
  })

  useEffect(() => {
    if (countDown > 1) playSound(numericCountDownSound)
    const timeout = setTimeout(() => {
      if (countDown === 0) {
        setNextStep()
      } else {
        if (countDown === 1) playSound(goCountDownSound)
        else playSound(numericCountDownSound)
        setCountDown((prevCountDownText) => prevCountDownText - 1)
      }
    }, 1000)
    return () => clearTimeout(timeout)
  }, [countDown])

  return (
    <div className="relative flex items-center justify-center h-screen">
      {tranistions((style, item) => (
        <animated.div
          style={{
            ...style,
            position: 'absolute',
            backgroundColor: '#00000044',
          }}
          className={classNames(
            'text-center text-8xl w-full opacity-25 text-white',
            { 'font-600': item === 'GO' }
          )}
        >
          {item}
        </animated.div>
      ))}
    </div>
  )
}

export default CountDown
